import React, { Component } from 'react'
import deleteGif from '../../../src/assets/assets_theme/img/trash-can.gif'
import blockUser from '../../../src/assets/assets_theme/img/block-user-man.png'
import approveUser from '../../../src/assets/assets_theme/img/approve-user-man.png'
import avatar1 from '../../../src/assets/assets_theme//img/avatar/1.jpg'

export class CustomModalAttendantUser extends Component {

constructor(props) {
  super(props);
  this.state = {
    data: this.props.data,
    admin_feedback: "",
  }
}

handleSubmit(e, status) {
  this.props.approveUser(e, {apply_leave_status_id: status, admin_feedback: this.state.admin_feedback})
}

render() {
  let data = this.props.data;
  let user_data = this.props.user_data;
  let title = this.props.title;
  let deleteQuiz = this.props.deleteQuiz;
  let apply_leave_status_id = 1;
  return (
    <div className="modal modal-center fade" id="modal-center-approveattandantuser" tabindex="-1">
        <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div className="modal-body">
            <div class="media" style={{alignItems: 'center'}}>
                {/* <img class="avatar" src={user_data.profile_url ? user_data.profile_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." /> */}
                {user_data && <img class="avatar" src={user_data.profile_url ? user_data.profile_url : avatar1} alt="..." />}
                <div class="media-body">
                <h6> 
                  { 
                    user_data && <div> { user_data.last_name ? user_data.last_name : ''}
                      {user_data.first_name ? user_data.first_name : ''}  { user_data.nick_name ? user_data.nick_name : ''}</div>
                  }
                </h6>
                </div>
              </div>




            <h6> 
              { data.name_kh ? data.name_kh : ''} { data.name_en ? data.name_en : ''} 
              { data.title_kh ? data.title_kh : ''} { data.title_en ? data.title_en : ''}
              { data.first_name ? data.first_name : ''} { data.last_name ? data.last_name : ''} { data.nick_name ? data.nick_name : ''}
            </h6>
            {/* <img className='center' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px', width: '500px'}} src={blockUser} />
             */}

             {/* <img className='center' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px', width: '500px'}} src={data.id_card_url? data.id_card_url : approveUser} /> */}
             {/* <img className='center' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px', width: '500px'}} src={data.id_card_url? data.id_card_url : approveUser} /> */}
             <div className="form-group col-md-12">
                <label className="require" for="input-required">Feedback</label>
              <textarea type="text" className="form-control" id="input-required" name="feedback" style={{height: 200}}
                value={this.state.admin_feedback}
                onChange={(event) => {
                  this.state.admin_feedback = event.target.value;
                  this.setState({});
                }}
              />
            </div> 
            </div>
            <div className="modal-footer">
            <button type="button" className="btn btn-bold btn-pure btn-secondary" data-dismiss="modal" >Cancel</button>
            <button type="button" className="btn btn-bold btn-pure btn-danger" data-dismiss="modal" onClick={(e) => this.handleSubmit(e, 3)}>Reject</button>
            {/* <button type="button" className="btn btn-bold btn-pure btn-danger" data-dismiss="modal" onClick={this.props.blockUser}>{this.props.data.block ? 'Unblock' : 'Block'}</button> */}
            <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={(e) => this.handleSubmit(e, 2)}>{'Approve'}</button>

            {/* {data.approve == 0 && data.block == 0  && <button type="button" className="btn btn-bold btn-pure btn-info" data-dismiss="modal" onClick={this.props.approveUser}>Approve</button>} */}


            {/* <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={this.props.blockUser}>Block</button> */}
            </div>
        </div>
        </div>
    </div>
  )
}
}

export default CustomModalAttendantUser